import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/auth';


import { defineComponent as __MACROS_defineComponent } from "vue";
const __default__ = __MACROS_defineComponent({
	name: 'AppMain',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

;

/**
 * 🎯 Accesso diretto al store Pinia
 * Ora utilizziamo solo Pinia come fonte di verità per l'autenticazione
 */
const authStore = useAuthStore();

/**
 * ⚡ Reactive references dal store Pinia
 * userInfo è automaticamente reattivo grazie a storeToRefs()
 * I dati vengono caricati dalla persistenza SecureLS
 */
const { userInfo } = storeToRefs(authStore);

/**
 * Flag per modalità sviluppo
 */
const isDevMode = computed((): boolean => {
	return process.env.DEV_MODE === 'true';
});

return { __sfc: true,authStore, userInfo, isDevMode }
}

})